import axios from 'axios';

export default async function addResponsibles({
  accessToken,
  companyId,
  responsible_ids,
  setTokenLikeExpired,
}) {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_COMPANIES_API_URL}/responsible/add/${companyId}`,
      { responsible_ids },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return err;
  }
}
